<template>
<!-- 兑换精选配置 -->
    <div class="exchangeConfig">
        <h4 class="describe">热门互动</h4>
        <div class="exchangeWrap">
            <h6 class="tips">兑换配置</h6>
            <div class="show">
                <span>说明：</span>
                <span>1、在积分商城活动列表中的活动均会在列表展示，可通过显示/隐藏控制在C端的显示；</span>
                <span>2、该模块最多显示3个活动，当超过3个时，取顶部3个活动进行展示；不足3个时，按实际活动数量展示；</span>
            </div>
            <!-- 配置表格 -->
            <configTable :notDesc="false" :configHead="configHead" :configList="pageConfig.menberPage.exchangeList"></configTable>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import configTable from '../configTable'

export default {
    components: {
        configTable
    },
    computed: {
        ...mapState(["pageConfig"])
    },
    data() {
        return {
            configHead: [
                {name: '活动名称', flex: 2},
                {name: '状态', flex: 2},
                {name: '图标', flex: 1},
                {name: '排序', flex: 1},
                {name: '操作', flex: 1},
            ],
        }
    }
}
</script>

<style scoped lang="scss">
.exchangeConfig {
    .describe {
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding-left: 28px;
        margin: 0;
        text-align: left;
        height: 64px;
        background-color: #f5f5f5;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        .desc {
            margin-top: 5px;
            color: #999;
            font-size: 14px;
            font-weight: 400;
        }
    }
    .exchangeWrap {
        box-sizing: border-box;
        padding: 20px 28px;
        text-align: left;
        border-bottom: 1px solid #F3F3F3;
        .tips {
            position: relative;
            display: inline-block;
            color: #333;
            font-size: 14px;
            font-weight: 500;
            &::after {
                content: '*';
                position: absolute;
                right: -8px;
                top: 2px;
                color: #FF3A27;
            }
        }
        .show {
            display: flex;
            flex-direction: column;
            margin-top: 14px;
            color: #333;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            span {
                &:first-child { margin-bottom: 5px; font-size: 14px; }
            }
        }
    }
}
</style>